import config from 'cityads-v3/config';
import { mapIds, mapObjectize } from 'cityads-v3/utils/apiUtils';
import {
  GO_FIRST_PAGE,
  GO_NEXT_PAGE,
  SET_CREATION_DATA,
  UPDATE_CREATION_DATA,

  GET_WIDGETS,
  GET_WIDGETS_SUCCESS,
  GET_WIDGETS_FAIL,
  GET_TEMPLATES,
  GET_TEMPLATES_SUCCESS,
  GET_TEMPLATES_FAIL,
  GET_TEMPLATES_BY_OFFER_ID,
  GET_TEMPLATES_BY_OFFER_ID_SUCCESS,
  GET_TEMPLATES_BY_OFFER_ID_FAIL,
  GET_TEMPLATE_BY_ID,
  GET_TEMPLATE_BY_ID_SUCCESS,
  GET_TEMPLATE_BY_ID_FAIL,
  REMOVE_WIDGET,
  REMOVE_WIDGET_SUCCESS,
  REMOVE_WIDGET_FAIL,
  SAVE_WIDGET,
  SAVE_WIDGET_SUCCESS,
  SAVE_WIDGET_FAIL,
  LOAD_WIDGET,
  LOAD_WIDGET_SUCCESS,
  LOAD_WIDGET_FAIL,
  LOAD_WIDGET_OFFERS,
  LOAD_WIDGET_OFFERS_SUCCESS,
  LOAD_WIDGET_OFFERS_FAIL,
} from "../actions/widgets";


const initialState = {
  widgets: [],
  widgetsById: {},
  templates: [],
  templatesById: {},
  templatesByOfferId: {},
  widgetOffers: [],
  widgetOffersById: {},

  creationPage: {
    currentPage: 0,
    data: {},
    errors: {},
  },

  isTemplatesLoaded: false
};

const debugData = {
  widget: [{
    id: 1,
    name: 'Sravni.ru vertical banks',
    image: 'http://monlivre.ru/_mod_files/ce_images/eshop/generated/600-701_400x300_pc.jpg',
    is_draft: false,
    is_active: true,
    template_id: 1,
    placement_codes: [
      {
        channel_id: 1,
        code: 'asdasda'
      }
    ],
    options: [
      {
        widget_template_option_id: 1,
        value: 'asdasd'
      }
    ]
  }, {
    id: 2,
    name: 'Sravni.ru horizontal banks',
    image: 'http://grant-el.ru/media/k2/items/cache/a1ca2d478cdfb0fd066e78050f4af09b_XL.jpg',
    is_draft: false,
    is_active: true,
    template_id: 1,
    placement_codes: [
      {
        channel_id: 1,
        code: 'asdasda'
      }
    ],
    options: [
      {
        widget_template_option_id: 1,
        value: 'asdasd'
      }
    ]
  }],
  templates: [{
    id: 1,
    name: '[DEBUG] Шаблон 1',
    code_template: 'tralala',
    offer_id: 29675,
    is_active: true,
    options: [
      {
        id: 1,
        name: '[DEBUG] Ширина',
        placeholder: 'width',
        type_name: 'int',
        rule: {},
        default_value: 500
      }
    ]
  }]
}

export function normalizeWidgetTemplate(template) {
  return {
    ...template,
    id: Number(template.id),
    options: template.options
      .map(({ id, ...rest }) => ({
        id: Number(id),
        ...rest,
      }))
      .sort((op1, op2) => op1.id - op2.id)
    ,
  }
}

export function normalizeWidget(widget) {
  return {
    ...widget,
    id: Number(widget.id),
    template_id: Number(widget.template_id),
    is_draft: Number(widget.is_draft),
    is_active: Number(widget.is_active),
    offerId: Number(widget.offer_id),
  }
}

export default function widgets(state = initialState, action = {}) {
  switch (action.type) {
    case GET_WIDGETS:
      return {
        ...state,
        isLoadingWidgets: true
      };
    case GET_WIDGETS_SUCCESS:
      const widgets = action.response.widget.map(normalizeWidget);

      return {
        ...state,
        widgets: mapIds(widgets),
        widgetsById: {
          ...state.widgetsById,
          ...mapObjectize(widgets),
        },
        isLoadingWidgets: false,
        isWidgetsLoaded: true
      };
    case GET_WIDGETS_FAIL:
      return {
        ...state,
        isLoadingWidgets: false,
        widgets: mapIds(config.DEBUG ? debugData.widget : []),
        widgetsById: {
          ...state.widgetsById,
          ...mapObjectize(config.DEBUG ? debugData.widget : []),
        }
      };

    case LOAD_WIDGET:
      return {
        ...state,
        isLoadingWidgets: true
      };
    case LOAD_WIDGET_SUCCESS:
      const widget = action.response.widget;
      const response = [normalizeWidget(widget)];

      return {
        ...state,
        widgets: mapIds(response),
        widgetsById: {
          ...state.widgetsById,
          ...mapObjectize(response),
        },
        isLoadingWidgets: false
      };
    case LOAD_WIDGET_FAIL:
      return {
        ...state,
        isLoadingWidgets: false,
        widgets: mapIds(config.DEBUG ? debugData.widget : []),
        widgetsById: {
          ...state.widgetsById,
          ...mapObjectize(config.DEBUG ? debugData.widget : []),
        }
      };

    case LOAD_WIDGET_OFFERS:
      return {
        ...state,
        isLoadingWidgetOffers: true,
        isLoadedWidgetOffers: false,
      };
    case LOAD_WIDGET_OFFERS_SUCCESS:
      const widgetOffers = action.response.offer;

      return {
        ...state,
        isLoadingWidgetOffers: false,
        isLoadedWidgetOffers: true,
        widgetOffers,
        widgetOffersById: {
          ...state.widgetOffersById,
          ...mapObjectize(widgetOffers)
        }
      };
    case LOAD_WIDGET_OFFERS_FAIL:
      return {
        ...state,
        isLoadingWidgetOffers: false,
        isLoadedWidgetOffers: false,
      };

    case GET_TEMPLATES:
      return {
        ...state,
        isLoadingTemplates: true,
        isTemplatesLoaded: false,
      };
    case GET_TEMPLATES_SUCCESS:
      const templates = action.response.widgetTemplate.map(normalizeWidgetTemplate);

      return {
        ...state,
        templates: mapIds(templates),
        templatesById: {
          ...state.templatesById,
          ...mapObjectize(templates),
        },
        isLoadingTemplates: false,
        isTemplatesLoaded: true
      };
    case GET_TEMPLATES_FAIL:
      return {
        ...state,
        isLoadingTemplates: false,
        templates: mapIds(config.DEBUG ? debugData.templates : []),
        templatesById: {
          ...state.templatesById,
          ...mapObjectize(config.DEBUG ? debugData.templates : []),
        },
        isTemplatesLoaded: false
      };

    case GET_TEMPLATES_BY_OFFER_ID:
      return ((offerId) => ({
        ...state,
        templatesByOfferId: {
          ...state.templatesByOfferId,
          [offerId]: {
            ...state.templatesByOfferId[offerId],
            isLoading: true,
          }
        }
      }))(state, action.additional.offerId);

    case GET_TEMPLATES_BY_OFFER_ID_SUCCESS:
      return ((state, offerId, templates) => ({
        ...state,
        templatesById: {
          ...state.templatesById,
          ...mapObjectize(templates),
        },
        templatesByOfferId: {
          ...state.templatesByOfferId,
          [offerId]: {
            templates: mapIds(templates),
            isLoading: false,
            isLoaded : true,
          }
        }
      }))(state, action.additional.offerId, action.response.widgetTemplate.map(normalizeWidgetTemplate));

    case GET_TEMPLATES_BY_OFFER_ID_FAIL:
      return ((state, offerId, templates) => ({
        ...state,
        templatesById: {
          ...state.templatesById,
          ...mapObjectize(templates),
        },
        templatesByOfferId: {
          ...state.templatesByOfferId,
          [offerId]: {
            templates: mapIds(templates),
            isLoading: false,
            isLoaded : false,
          }
        }
      }))(state, action.additional.offerId, config.DEBUG ? debugData.templates : []);

    case GET_TEMPLATE_BY_ID:
      return {
        ...state,
        isLoadingTemplateById: true,
      }

    case GET_TEMPLATE_BY_ID_SUCCESS:
      return {
        ...state,
        isLoadingTemplateById: false,
        templatesById: {
          ...state.templatesById,
          [action.response.widgetTemplate.id]: normalizeWidgetTemplate(action.response.widgetTemplate)
        }
      }

    case GET_TEMPLATE_BY_ID_FAIL:
      return {
        ...state,
        isLoadingTemplateById: false,
      }

    case REMOVE_WIDGET:
      return {
        ...state,
        isRemovingWidget: true
      };
    case REMOVE_WIDGET_SUCCESS:
      return {
        ...state,
        isRemovingWidget: false,
        widgets: [
          ...state.widgets.filter(item => +item !== +action.additional.id)
        ]
      };
    case REMOVE_WIDGET_FAIL:
      return {
        ...state,
        isRemovingWidget: false,
        widgets: [
          ...(config.DEBUG ? state.widgets.filter(item => item.id !== action.additional.id) : state.widgets)
        ]
      };

    case SAVE_WIDGET:
      return {
        ...state,
        isSavingWidget: true
      };
    case SAVE_WIDGET_SUCCESS:
      let savedWidget = action.response.widget;

      return {
        ...state,
        isSavingWidget: false,
        widgets: [
          ...state.widgets,
          savedWidget.id
        ],
        widgetsById: {
          ...state.widgetsById,
          [savedWidget.id]: savedWidget
        },
        creationPage: {
          ...state.creationPage,
          errors: {}
        },
      };
    case SAVE_WIDGET_FAIL:
      return {
        ...state,
        isSavingWidget: false,
        creationPage: {
          ...state.creationPage,
          errors: (action.response && action.response.data && action.response.data.form_errors) || {}
        },
      };

    case GO_FIRST_PAGE:
      return {
        ...state,
        creationPage: {
          ...state.creationPage,
          currentPage: 0
        }
      }

    case GO_NEXT_PAGE:
      const currentPage = action.page === false ? state.creationPage.currentPage + 1 : action.page;
      return {
        ...state,
        creationPage: {
          ...state.creationPage,
          currentPage
        }
      }

    case SET_CREATION_DATA:
      return {
        ...state,
        creationPage: {
          ...state.creationPage,
          data: action.data,
          errors: {},
        }
      }

    case UPDATE_CREATION_DATA:
      return ((state, action) => {
        const errors = state.creationPage.errors;
        const data = action.data;

        return {
          ...state,
          creationPage: {
            ...state.creationPage,
            data: {
              ...state.creationPage.data,
              ...action.data,
            },
            errors: Object.keys(errors)
              .filter(errorKey => !data.hasOwnProperty(errorKey))
              .reduce((acc, errorKey) => {
                acc[errorKey] = errors[errorKey];
                return acc;
              }, {})
          }
        }
      })(state, action);

    default:
      return state;
  }
}
